import AdminLayout from '../../../components/layout/AdminLayout';
import UserForm from '../../../components/forms/UserForm';
import { UserClient, UserCreateDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import { authorisedFetch } from '../../../utils/fetchUtils';
import Card from '../../../components/common/Card';
import React, { useState } from "react";
import axiosInstance from '../../../services/axiosInstance';

const UserCreate: React.FC = () => {
  const [profilePicture, setProfilePicture] = useState<File | null>(null);
  const navigate = useNavigate();
  const apiClient = new UserClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Users', href: '/admin/users' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: UserCreateDTO) => {
    try {
      if (profilePicture) {
        // Call the method to upload the logo image
        const uploadResponse = await apiClient.uploadProfilePicture(
          profilePicture.name,
          profilePicture,
        );

        if (uploadResponse && uploadResponse.success) {
            data.profilePicture = uploadResponse.data;
        }
    }

    

      var response = await apiClient.createUser(data);
      if(response.success && response.data){
        localStorage.removeItem(`profilePic_${response.data?.id}`)
        navigate('/admin/users');
      }
    } catch (error) {
      console.error('Error creating user:', error);
    } finally {
    }
  };

  return (
    <AdminLayout
      title="Create User"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        <UserForm
          initialValues={{} as UserCreateDTO}
          onSave={handleSubmit}
          setProfilePicture={setProfilePicture}
          onCancel={() => navigate('/admin/users')}
          isCreating={true}
        />
      </Card>
    </AdminLayout>
  );
};

export default UserCreate;
